import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import SingleNotification from './SingleNotification';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotificationList } from './redux/dispatcher';
import NoNotification from './NoNotification';

function Notification({ args, toggle, modal }) {

    const dispatch = useDispatch();
    const notificationList = useSelector((state) => state.notificationReducer);
    const [page, setPage] = useState(1);
    const isFetching = useRef(false);

    const notificationData = Array.isArray(notificationList?.data) ? notificationList.data : [];
    const isLoading = notificationList?.isLoading;
    const hasMore = notificationList?.page < notificationList?.totalPage;

    // Reset and fetch page 1 when modal opens
    useEffect(() => {
        if (modal) {
            setPage(1);
            dispatch(fetchNotificationList({ page: 1, limit: 20 }));
        }
    }, [modal, dispatch]);

    // Fetch subsequent pages
    useEffect(() => {
        if (page > 1) {
            dispatch(fetchNotificationList({ page, limit: 20 }));
        }
    }, [page, dispatch]);

    // Mark fetching done when loading stops
    useEffect(() => {
        if (!isLoading) {
            isFetching.current = false;
        }
    }, [isLoading]);

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop - clientHeight < 80 && !isFetching.current && hasMore) {
            isFetching.current = true;
            setPage(prev => prev + 1);
        }
    };

    return (
        <div>
            <Modal isOpen={modal} toggle={toggle} {...args} className="notification-modal" size="lg">
                <ModalHeader toggle={toggle} style={{ backgroundColor: 'rgb(14, 61, 13)', color: 'white', borderBottom: 'none' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'white' }}>
                        <i className="fa-regular fa-bell" style={{ fontSize: '1.2rem' }}></i>
                        <span>Notifications ({notificationList?.total ?? notificationData.length})</span>
                    </div>
                </ModalHeader>
                <ModalBody
                    style={{ maxHeight: '500px', overflowY: 'auto', padding: '20px', backgroundColor: '#f8f9fa' }}
                    onScroll={handleScroll}
                >
                    {
                        notificationData.length > 0 ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                {notificationData.map((item) => (
                                    <SingleNotification key={item?.id} data={item} />
                                ))}
                            </div>
                        ) : (
                            !isLoading && <NoNotification />
                        )
                    }
                    {isLoading && (
                        <div style={{ textAlign: 'center', padding: '10px', color: '#666' }}>
                            Loading...
                        </div>
                    )}
                </ModalBody>
                <ModalFooter style={{ backgroundColor: '#f8f9fa', borderTop: '1px solid #dee2e6' }}>
                    <Button onClick={toggle} style={{
                        outline: 'none',
                        boxShadow: 'none',
                        backgroundColor: 'rgb(14, 61, 13)',
                        color: 'white',
                        border: 'none',
                        padding: '8px 20px',
                        borderRadius: '5px'
                    }}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default Notification;
